import { BlockTitle } from "@blocks/Blocks";
import DawnLimSection from "@dta/components/Judges/DawnLimSection";
import HuifenSection from "@dta/components/Judges/HuifenSection";
import JennyLeeSection from "@dta/components/Judges/JennyLeeSection";
import LeslieTeoSection from "@dta/components/Judges/LeslieTeoSection";
import TaiLeeSection from "@dta/components/Judges/TaiLeeSection";

/**
 * Component to render DTA judges page
 */
const DTAJudgesPage = (): React.ReactElement => {
  return (
    <div
      data-testid="dta-judges-page-component"
      className="mb-5 font-public-sans leading-[1.4]"
    >
      <BlockTitle
        text="Judges"
        rootClassName="pt-3 mb-5 text-3xl md:text-5xl lg:text-6xl font-medium font-poppins"
      />

      <TaiLeeSection />

      <HuifenSection />

      <DawnLimSection />

      <JennyLeeSection />

      <LeslieTeoSection />
    </div>
  );
};

export default DTAJudgesPage;
